import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../../constants/form'

export const QA_NAME_EDIT_PROPERTY_OWNERS_MODAL = 'editPropertyOwners'

export const BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_PROPERTY_OWNERS =
  'propertyOwners'

export const BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_ALL_FLATS =
  'property_owners_affect_flats'

export const BUILDING_EDIT_PROPERTY_OWNERS_FORM_BODY_PROPS = {
  ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION,
  validationErrorsNotificationProps: {
    ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION.validationErrorsNotificationProps,
  },
}
